// Cross-subdomain session storage for Supabase.
// On *.uplandgroupllc.com, the session is stored in a cookie scoped to the ".uplandgroupllc.com"
// apex so BOTH apps (main site + assessments subdomain) share one session -> one-click SSO.
// Anywhere else (e.g. the preview environment) it falls back to localStorage unchanged.
const APEX = ".uplandgroupllc.com";
const MAX = 3200; // stay under the ~4KB per-cookie limit; chunk larger session blobs
const onApex = typeof window !== "undefined" && window.location.hostname.endsWith("uplandgroupllc.com");

function writeCookie(name, value, days = 30) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; domain=${APEX}; path=/; expires=${expires}; Secure; SameSite=Lax`;
}
function readCookie(name) {
  const m = document.cookie.match(new RegExp("(^|; )" + name.replace(/[.$?*|{}()[\]\\/+^]/g, "\\$&") + "=([^;]*)"));
  return m ? decodeURIComponent(m[2]) : null;
}
function clearCookie(name) {
  document.cookie = `${name}=; domain=${APEX}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

// Supabase-compatible storage backed by chunked apex-domain cookies.
export const cookieStorage = {
  getItem(key) {
    const n = readCookie(`${key}.n`);
    if (!n) return readCookie(key); // single/legacy cookie
    let out = "";
    for (let i = 0; i < Number(n); i++) {
      const c = readCookie(`${key}.${i}`);
      if (c === null) return null;
      out += c;
    }
    return out;
  },
  setItem(key, value) {
    this.removeItem(key);
    const chunks = Math.ceil(value.length / MAX) || 1;
    writeCookie(`${key}.n`, String(chunks));
    for (let i = 0; i < chunks; i++) writeCookie(`${key}.${i}`, value.slice(i * MAX, (i + 1) * MAX));
  },
  removeItem(key) {
    const n = readCookie(`${key}.n`);
    if (n) {
      for (let i = 0; i < Number(n); i++) clearCookie(`${key}.${i}`);
      clearCookie(`${key}.n`);
    }
    clearCookie(key);
  },
};

// undefined => supabase-js uses its default localStorage (correct for preview / non-apex hosts)
export const sharedAuthStorage = onApex ? cookieStorage : undefined;
